// const ENDPOINT = 'https://tap.fendron.com/api/v1/'
// const ENDPOINT = 'http://localhost:8000/'
// const ENDPOINT = 'http://localhost/work/noortap/v/3/noortapapp/public/api/v1/'
// const ENDPOINT = 'https://testingapi.noortap.com/api/v1/'
const ENDPOINT = 'https://api.noortap.com/api/v1/'
//dev 'https://noortap.com/api/v1/';
//test 'https://tap.fendron.com/api/v1/'
export default ENDPOINT;